import React from "react";
//#region types
import { ToggleButtonProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import RoundButton from "./roundButton";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ToggleButtonGroup: React.FC<ToggleButtonProps> = (props) => {
  const [selectedBtn, setSelectedBtn] = React.useState<number>(0);

  React.useEffect(() => {
    if (props.initialSelectionKey !== undefined) {
      const index = props.buttons.findIndex((b) => b.buttonKey === props.initialSelectionKey);
      if (selectedBtn !== index) setSelectedBtn(index);
    }
  }, [props.initialSelectionKey]);

  const onButtonClick = (index: number, onClick?: React.MouseEventHandler<HTMLButtonElement>, event?: any) => {
    event?.stopPropagation();
    setSelectedBtn(index);
    onClick && onClick(event);
  };

  return (
    <Grid
      item
      className={clsx(cssExports.toggleButtonGroup, props.colorVariation === "dark" ? cssExports.dark : undefined)}
    >
      <Grid container spacing={1} direction="row" alignItems="center" className={cssExports.buttonGroupWrapper}>
        {props.buttons.map((button, index) => (
          <RoundButton
            key={index}
            size="xs"
            {...button}
            className={clsx(cssExports.toggleButton, index === selectedBtn ? cssExports.toggleButtonActive : "")}
            onClick={onButtonClick.bind(null, index, button.onClick)}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default ToggleButtonGroup;
